module.exports =
  '_HISTORY':
    'TITLE': 'History'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/history/i18n/en.coffee